"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var small = '0 2px 8px 0 rgba(0, 0, 0, 0.1)';
var medium = '0 4px 16px 0 rgba(0, 0, 0, 0.1)';
var large = '0 8px 32px 0 rgba(0, 0, 0, 0.3)';
var inner = 'inset 0px -11px 8px -10px rgba(0, 0, 0, 0.1)';
var _default = {
  small: small,
  medium: medium,
  large: large,
  inner: inner
};
exports.default = _default;
//# sourceMappingURL=shadows.js.map